import { Box, styled } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { WsColors } from 'wisestep-base';

import BenchConsultants from './BenchConsultants';
import Filters from './Filters';

export const LayoutTheme = styled(Box)(() => ({
  maxWidth: '100%',
  maxHeight: 'xs',
  backgroundColor: WsColors.TertiaryShades50,
  padding: 2,
}));

const ConsultantsListingPage = () => {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <LayoutTheme>
        <Box>
          <Filters />
          <BenchConsultants />
        </Box>
      </LayoutTheme>
    </FormProvider>
  );
};

export default ConsultantsListingPage;
